import { render, staticRenderFns } from "./cooperativeModal.vue?vue&type=template&id=6588f9b9&scoped=true"
import script from "./cooperativeModal.vue?vue&type=script&lang=js"
export * from "./cooperativeModal.vue?vue&type=script&lang=js"
import style0 from "./cooperativeModal.vue?vue&type=style&index=0&id=6588f9b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6588f9b9",
  null
  
)

export default component.exports